import { AttributeSettingsDTO } from '../DTOs/AttributeSettingsDTO';
import { Attribute } from './Attribute';
import { AttributeValueOrNumber } from './AttributeSettings/AttributeValueInstances/AttributeValueInstance';
import { AttributeValue } from './AttributeValue';
import { IdMapper, ProductBlueprint } from './ProductBlueprint';

export class AttributeSettings {
  public static createFromAttributeAndAttributeValue(attribute: Attribute, attributeValue: AttributeValueOrNumber) {
    const attributeSetting = new AttributeSettings(
      attribute.id,
      attributeValue instanceof AttributeValue ? attributeValue.id : undefined,
      undefined,
      typeof attributeValue === 'number' ? attributeValue : undefined,
    );
    attributeSetting.manuallySetValues(attribute, attributeValue);
    return attributeSetting;
  }

  id?: string;
  keyId: string;
  valueId?: string;
  key?: Attribute;
  value?: AttributeValue;
  numericValue?: number;
  priority: number;

  public static fromDTO(attributeSettingsDTO: AttributeSettingsDTO) {
    return new AttributeSettings(
      attributeSettingsDTO.key.toString(),
      attributeSettingsDTO.value?.toString(),
      attributeSettingsDTO.id?.toString(),
      attributeSettingsDTO.numericValue,
      attributeSettingsDTO.priority,
    );
  }

  constructor(key: string, value?: string, id?: string, numericValue?: number, priority = 0) {
    this.keyId = key;
    this.valueId = value;
    this.id = id;
    this.numericValue = numericValue;
    this.priority = priority;
  }

  public manuallySetValues(attribute: Attribute, attributeValue: AttributeValueOrNumber) {
    if (this.keyId === attribute.id) this.key = attribute;
    if (attributeValue instanceof AttributeValue && this.valueId === attributeValue.id) this.value = attributeValue;
    if (typeof attributeValue === 'number') this.numericValue = attributeValue;
  }

  public populateWithAttributes(availibleBlueprints: ProductBlueprint[], idMapper: IdMapper) {
    const mappedAttribute = idMapper.attributeMap.get(this.keyId);
    if (mappedAttribute) {
      this.key = mappedAttribute.attribute;
    }

    if (this.valueId) {
      const mappedAttributeValue = idMapper.attributeValueMap.get(this.valueId);
      if (mappedAttributeValue) {
        this.value = mappedAttributeValue;
      }
    }

    if (this.key && (this.value || this.numericValue)) return;

    for (const productBlueprint of availibleBlueprints) {
      this._recursivelyPopulateWithAttributes(productBlueprint.attributes, idMapper, productBlueprint);
    }
  }

  private _recursivelyPopulateWithAttributes(
    attributes: Attribute[],
    idMapper: IdMapper,
    productBlueprint: ProductBlueprint,
  ) {
    for (const attribute of attributes) {
      if (this.keyId === attribute.id) {
        this.key = attribute;
        idMapper.attributeMap.set(this.keyId, { attribute: attribute, productBlueprint: productBlueprint });
      }

      for (const attribteValue of attribute.attributeValues) {
        if (this.valueId === attribteValue.id) {
          this.value = attribteValue;
        }
        if (this.key && (this.value || this.numericValue)) return;
        this._recursivelyPopulateWithAttributes(attribteValue.attributes, idMapper, productBlueprint);
      }
    }
  }
}
